import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  IoCalendarOutline, 
  IoSearch, 
  IoCloseCircle, 
  IoBusiness, 
  IoPerson, 
  IoMedical, 
  IoDocumentText,
  IoCalendar
} from 'react-icons/io5';

// Web Storage wrapper (using localStorage)
const storage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      //console.error('Error getting item from localStorage:', error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      //console.error('Error setting item in localStorage:', error);
    }
  }
};

// Função para formatar data e hora
const dataHoraFormatada = (data, hora) => {
  if (!data) return 'Data não informada';
  
  try {
    // Formatar data (assumindo formato YYYY-MM-DD)
    const dataObj = new Date(data);
    const dataFormatada = dataObj.toLocaleDateString('pt-BR');
    
    // Formatar hora (assumindo formato HH:MM:SS)
    let horaFormatada = '';
    if (hora) {
      horaFormatada = hora.substring(0, 5); // Pega HH:MM
    }
    
    return horaFormatada ? `${dataFormatada} às ${horaFormatada}` : dataFormatada;
  } catch (error) {
    //console.error('Erro ao formatar data:', error);
    return data;
  }
};

// Styles
const styles = {
  mainContainer: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollContainer: {
    flex: 1,
    padding: '16px',
    maxWidth: '800px',
    margin: '0 auto',
    width: '100%',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
    minHeight: '400px',
  },
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #137a7f',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: '16px',
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '12px',
    paddingHorizontal: '16px',
    marginBottom: '20px',
    borderWidth: '1px',
    borderColor: '#ddd',
    borderStyle: 'solid',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  searchIcon: {
    marginRight: '12px',
    fontSize: '20px',
    color: '#999',
  },
  input: {
    flex: 1,
    height: '50px',
    fontSize: '16px',
    color: '#333',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
  },
  clearButton: {
    padding: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clearIcon: {
    fontSize: '20px',
    color: '#999',
  },
  resultsCount: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '16px',
    textAlign: 'center',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    borderWidth: '1px',
    borderColor: '#e0e0e0',
    borderStyle: 'solid',
    minHeight: '100px',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    paddingBottom: '16px',
    borderBottomWidth: '1px',
    borderBottomColor: '#f0f0f0',
    borderBottomStyle: 'solid',
  },
  cardIcon: {
    fontSize: '24px',
    color: '#137a7f',
    marginRight: '12px',
  },
  cardDate: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#137a7f',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  infoRow: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  infoIcon: {
    marginTop: '2px',
    marginRight: '12px',
    fontSize: '18px',
    color: '#666',
  },
  infoText: {
    flex: 1,
  },
  label: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#999',
    marginBottom: '2px',
    textTransform: 'uppercase',
  },
  value: {
    fontSize: '16px',
    color: '#333',
    lineHeight: '22px',
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
  },
  emptyIcon: {
    fontSize: '64px',
    color: '#ccc',
  },
  emptyText: {
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
    marginTop: '16px',
  },
  emptySubText: {
    fontSize: '14px',
    color: '#666',
    textAlign: 'center',
    marginTop: '8px',
  },
  navbar: {
    backgroundColor: '#137a7f',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  navbarTitle: {
    color: 'white',
    fontSize: '18px',
    fontWeight: '600',
    margin: 0,
  },
  backButton: {
    position: 'absolute',
    left: '20px',
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  backButtonText: {
    fontSize: '14px',
  },
  footer: {
    backgroundColor: '#f5f5f5',
    padding: '10px',
    textAlign: 'center',
    borderTopWidth: '1px',
    borderTopColor: '#e0e0e0',
    borderTopStyle: 'solid',
  },
  footerText: {
    fontSize: '12px',
    color: '#666',
    margin: 0,
  },
};

// Add keyframes animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

// NavBar Component
const NavBar = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.navbar}>
      {showBackButton && (
        <button
          onClick={() => navigate(-1)}
          style={styles.backButton}
        >
          ← <span style={styles.backButtonText}>Voltar</span>
        </button>
      )}
      <h1 style={styles.navbarTitle}>{title}</h1>
    </div>
  );
};

// Footer Component
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer style={styles.footer}>
      <p style={styles.footerText}>© {currentYear} - Sistema de Saúde</p>
    </footer>
  );
};

export default function AgendamentosScreen() {
  const [agendamentos, setAgendamentos] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedPesCod = storage.getItem('cpf');
        const storedLink = storage.getItem('link');
        const storedChave = storage.getItem('chave');
        const storedGuid = storage.getItem('govbr_guid');
        const guidParam = storedGuid ? `&GUID=${storedGuid}` : '';
        //console.log('GUID ARMAZENADO:',guidParam)

        if (!guidParam) {
          setLoading(false);
          return;
        }

        const url = `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=agendamentos&p10=${storedPesCod}${guidParam}`;
        //console.log('URL da API (agendamentos):', url);
        
        const response = await fetch(url);
        const data = await response.json();

        //console.log('Resposta da API (agendamentos):', data);

        if (data.status === 'success' && data.dados && data.dados.length > 0) {
          setAgendamentos(data.dados);
        } else {
          //console.log('API não retornou agendamentos válidos');
          setAgendamentos([]);
        }
      } catch (error) {
        //console.log('Erro ao buscar agendamentos:', error);
        setAgendamentos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Função para verificar se há dados
  const hasAnyData = () => {
    return Array.isArray(agendamentos) && agendamentos.length > 0;
  };

  const agendamentosFiltrados = agendamentos.filter(item => {
    const searchText = filtro.toLowerCase();
    const matchesSearch =
      item.PRO_NOME?.toLowerCase().includes(searchText) ||
      item.UND_NOME?.toLowerCase().includes(searchText) ||
      item.OCU_NOME?.toLowerCase().includes(searchText);

    return matchesSearch;
  });

  return (
    <div style={styles.mainContainer}>
      <NavBar title="Agendamentos" showBackButton={true} />

      <div style={styles.scrollContainer}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.loadingSpinner} />
            <div style={styles.loadingText}>Carregando agendamentos...</div>
          </div>
        ) : !hasAnyData() ? (
          <div style={styles.emptyContainer}>
            <IoCalendarOutline style={styles.emptyIcon} />
            <div style={styles.emptyText}>Nenhum agendamento encontrado</div>
            <div style={styles.emptySubText}>
              Consulte a Unidade de Saúde para agendar seus procedimentos.
            </div>
          </div>
        ) : (
          <>
            <div style={styles.searchContainer}>
              <IoSearch style={styles.searchIcon} />
              <input
                type="text"
                style={styles.input}
                placeholder="Pesquisar por profissional, unidade ou especialidade..."
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
              {filtro.length > 0 && (
                <button 
                  onClick={() => setFiltro('')} 
                  style={styles.clearButton}
                >
                  <IoCloseCircle style={styles.clearIcon} />
                </button>
              )}
            </div>

            <div style={styles.resultsCount}>
              {agendamentosFiltrados.length} agendamento{agendamentosFiltrados.length !== 1 ? 's' : ''} encontrado{agendamentosFiltrados.length !== 1 ? 's' : ''}
            </div>

            {agendamentosFiltrados.length > 0 ? (
              agendamentosFiltrados.map((item, index) => (
                <div key={index} style={styles.card}>
                  <div style={styles.cardHeader}>
                    <IoCalendar style={styles.cardIcon} />
                    <div style={styles.cardDate}>
                      {dataHoraFormatada(item.AAP_DATA, item.AAP_HORA_ATENDIMENTO)}
                    </div>
                  </div>

                  <div style={styles.cardContent}>
                    <div style={styles.infoRow}>
                      <IoBusiness style={styles.infoIcon} />
                      <div style={styles.infoText}>
                        <div style={styles.label}>Unidade</div>
                        <div style={styles.value}>{item.UND_NOME || 'Não informado'}</div>
                      </div>
                    </div>

                    <div style={styles.infoRow}>
                      <IoPerson style={styles.infoIcon} />
                      <div style={styles.infoText}>
                        <div style={styles.label}>Profissional</div>
                        <div style={styles.value}>{item.PRO_NOME || 'Não informado'}</div>
                      </div>
                    </div>

                    <div style={styles.infoRow}>
                      <IoMedical style={styles.infoIcon} />
                      <div style={styles.infoText}>
                        <div style={styles.label}>Especialidade</div>
                        <div style={styles.value}>{item.OCU_NOME || 'Não informado'}</div>
                      </div>
                    </div>

                    <div style={styles.infoRow}>
                      <IoDocumentText style={styles.infoIcon} />
                      <div style={styles.infoText}>
                        <div style={styles.label}>Procedimento</div>
                        <div style={styles.value}>{item.PRU_NOME || 'Não informado'}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div style={styles.emptyContainer}>
                <IoCalendarOutline style={styles.emptyIcon} />
                <div style={styles.emptyText}>
                  {filtro ? 'Nenhum agendamento encontrado para a pesquisa.' : 'Nenhum agendamento encontrado.'}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {/* <Footer /> */}
    </div>
  );
}